import type { MeterBarChartThresholdIndicatorProps } from '../types/meter-bar-chart.js';

export const ThresholdIndicator = (
  props: MeterBarChartThresholdIndicatorProps,
) => null;

ThresholdIndicator['displayName'] = 'MeterBarChart.ThresholdIndicator';
